import { DataSmartTableProps } from "@/Layouts/components/types";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";
import CommonToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";

export const CUSTOM_PROPS: DataSmartTableProps["customProps"] = {
	tableContainerClassName: "[&_.MuiDataGrid-main]:mt-2 after:[&_.MuiDataGrid-topContainer]:!bg-disabled",
	tableClassName: {
		"[&_.MuiDataGrid-columnHeaderTitleContainer]:!items-start": true,
		"[&_.MuiDataGrid-columnHeader--withRightBorder]:!border-none": true,
		"display-select-all-checkbox": true,
		"[&_.MuiDataGrid-filler--pinnedLeft]:!border-r-transparent": true,
		"[&_.MuiDataGrid-row:not(.footer):hover_.MuiDataGrid-cell--pinnedLeft:not(.empty-row,.group-child)]:shadow-table-hov": true,
		"[&_.toolbar-actions]:!right-0": true,
	},
	aggregationFooterClassName: "aggregation-footer regular-footer",
	expandableRows: false,
	hide: false,
};

export const SLOTS = {
	toolbar: CommonToolbar,
	noRowsOverlay: NoRowsOverlay,
	noResultsOverlay: NoRowsOverlay,
};

export const CELL_CLASS_NAME = "!font-sans !text-[12px] text-default";
